import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  pure: true,
  name: 'join',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  transform(input: any[], sep = ', '): string {
    return input.join(sep);
  }
}
